module.exports = __webpack_public_path__ + "media/images/icon/hand-8a6355e47181105156611d872e1e421c.svg";